import Modal from '../modals/Modal';
import './UserDepartmentsModal.css';

/**
 * Read-only list of a user's assigned departments (profile page + Users table).
 */
const UserDepartmentsModal = ({
  isOpen,
  onClose,
  userName,
  departments = [],
}) => {
  const count = departments.length;
  const intro = userName
    ? `${userName} is assigned to ${count} department${count === 1 ? '' : 's'}.`
    : (count === 1
      ? 'Assigned to 1 department.'
      : `Assigned to ${count} departments.`);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Assigned Departments"
      size="small"
      className="user-departments-modal"
    >
      <p className="user-departments-modal__intro">
        {intro}
      </p>
      <ul className="user-departments-modal__list">
        {departments.map((dept) => (
          <li key={dept.id || dept.name} className="user-departments-modal__chip">
            <span className="user-departments-modal__chip-icon" aria-hidden="true">
              {dept.icon || '🏢'}
            </span>
            {dept.name}
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default UserDepartmentsModal;
